import { render, staticRenderFns } from "./sftcsetting.vue?vue&type=template&id=3553705c&scoped=true"
import script from "./sftcsetting.vue?vue&type=script&lang=js"
export * from "./sftcsetting.vue?vue&type=script&lang=js"
import style0 from "./sftcsetting.vue?vue&type=style&index=0&id=3553705c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3553705c",
  null
  
)

export default component.exports